import React, { useState } from 'react';
import './progressBar.scss';

const ProgressBar = ({ step, isSymblDemo = false }) => {
  const getStatusText = () => {
    switch (step) {
      case 0:
        return 'Uploading conversation...';
      case 1:
        return 'Upload complete! Processing transcription...';
      case 2:
        return 'Transcription complete! Processing call-score...';
      case 3:
        return 'Generated call-score! Please hold one final moment...';
      default:
        return '';
    }
  };

  const getBarClass = (barIndex) => {
    return step >= barIndex ? 'progress-bar filled' : 'progress-bar';
  };
  return (
    <div className="progress-container">
      <p style={isSymblDemo ? {fontSize: '1.5rem', fontWeight: 'bold'} : {}}>{getStatusText()}</p>
      <div className="progress-bars">
        <div className={getBarClass(1)}></div>
        <div className={getBarClass(2)}></div>
        <div className={getBarClass(3)}></div>
      </div>
    </div>
  );
};

export default ProgressBar;
